import { apiClient } from './client'
import type { User } from '@/types/auth'

export interface CreateUserPayload {
  name: string
  email: string
  role: 'admin' | 'controller' | 'supervisor' | 'vendor'
  password: string
  password_confirmation: string
}

export interface UsersListResponse {
  data: User[]
  meta: { current_page: number; last_page: number; total: number; per_page: number }
}

export const usersApi = {
  list: async (params?: { page?: number; search?: string; role?: string }): Promise<UsersListResponse> => {
    const { data } = await apiClient.get('/admin/users', { params })
    return { data: data.data, meta: data.meta }
  },

  listSupervisors: async (): Promise<User[]> => {
    const { data } = await apiClient.get('/admin/users', { params: { role: 'supervisor', per_page: 100 } })
    return data.data
  },

  listVendors: async (): Promise<User[]> => {
    const { data } = await apiClient.get('/admin/users', { params: { role: 'vendor', per_page: 100 } })
    return data.data
  },

  create: async (payload: CreateUserPayload): Promise<User> => {
    const { data } = await apiClient.post('/admin/users', payload)
    return data.data
  },

  toggleActive: async (id: number): Promise<User> => {
    const { data } = await apiClient.patch(`/admin/users/${id}/toggle`)
    return data.data
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/admin/users/${id}`)
  },
}
